export enum BoosterType {
    Mine = "mine",
    Energy = "energy",
    Freeze = "freeze",
    Turret = "turret"
}
